<template>
    <div v-if="confirm">
        <button class="btn" :class="size" @click="confirm=false">{{$t('No')}}</button>
        <button class="btn btn-white" :class="size" @click="ok">{{$t('Yes')}}</button>
    </div>

    <button :class="buttonClass ? buttonClass : 'btn btn-white'" @click="confirm=true" v-else>
        <slot></slot>
    </button>
</template>
<script>
export default {
    props: {
        buttonClass: String,
        size: {
            type: String,
            default: 'btn-sm'
        },
    },
    data() {
        return {
            confirm: false,
        }
    },
    methods: {
        ok() {
            this.confirm = false;
            this.$emit('confirm', true);
        }
    }
}
</script>
